// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';

const Title = function ({ level, icon, color, label, secondaryLabel, avatar }) {
  if (level === 1) {
    return (
      <div className="d-flex align-items-center pe-3">
        {avatar !== undefined ?
          <div className="pe-2 pt-1 pb-2">
            <div className={'image-lg mx-auto bg-gray-lighter'}>
              {avatar ?
                <img src={avatar} alt="Image" className="img-fluid rounded-circle" /> :
                null
              }
            </div>
          </div> :
          <div className="pe-2 pt-1 pb-2">
            <div className={'rounded bg-' + (color ?? 'black') + ' text-white'}>
              <div className="p-2">
                {icon ? React.createElement(icon, { size: 'lg' }) : null}
              </div>
            </div>
          </div>
        }
        {secondaryLabel ?
          <div className="fs-5 fw-bold">
            <div>{label}</div>
            <div className="fs-6 text-muted fw-light">{secondaryLabel}</div>
          </div> :
          <div className="pt-1 fs-4 fw-bold">
            {label}
          </div>
        }
      </div>
    );
  }
  else {
    return (
      <div className="d-flex align-items-center ps-1 pe-3">
        {avatar !== undefined ?
          <div className="pe-2">
            <div className="image-sm mx-auto bg-gray-lighter">
              {avatar ?
                <img src={avatar} alt="Image" className="img-fluid rounded-circle" /> :
                null
              }
            </div>
          </div> :
          <div className="ps-1 pe-3">
            {React.createElement(icon, { size: 'sm' }, null)}
          </div>
        }
        <div className="py-2 fw-6 fw-bold">
          {label}
        </div>
      </div>
    );
  }
}

export default Title;